/**
 * English dictionary — keys must mirror zh.ts exactly.
 * (中文为主语言, 英文为切换目标; 缺键时 useI18nLite 会回退到 zh)
 */
export const en: Record<string, string> = {
  // ===== Navigation =====
  'nav.analyze': '📊 Analyze',
  'nav.batch': '📦 Batch',
  'nav.tasks': '⚡ Tasks',
  'nav.chat': '💬 AI Chat',
  'nav.watchlist': '⭐ Watchlist',
  'nav.screener': '🎯 Screener',
  'nav.stockCompare': '⚖️ Compare',
  'nav.funds': '🍕 Funds/ETF',
  'nav.macro': '🌐 Macro',
  'nav.market': '📈 Market Review',
  'nav.portfolio': '💼 Portfolio',
  'nav.alerts': '🔔 Alerts',
  'nav.factors': '🧪 Factors',
  'nav.portfolioBacktest': '📈 Backtest',
  'nav.factorBacktest': '🎯 Factor Backtest',
  'nav.caseLibrary': '📚 Case Library',
  'nav.paperDeployments': '🧪 Paper Deployments',
  'nav.strategyLab': '🧪 Strategy Lab',
  'nav.retrospective': '🏆 Retrospective',
  'nav.anomalyScanner': '⚡ Anomalies',
  'nav.history': '📜 History',
  'nav.autoResearch': '🧭 Auto Research',
  'nav.researchOps': '🧾 Evidence Workbench',
  'nav.settings': '⚙️ Settings',
  'nav.agentBacktest': '🧪 Agent Evaluation',
  'nav.fundFlow': '💹 Fund Flow',
  'nav.arbitrage': '⚖️ AH Arb',
  'nav.earningsCalendar': '📅 Earnings',
  'nav.options': '🎯 Options Strategies',
  'nav.cbond': '🪙 CBond Workbench',
  'nav.sectorRrg': '🔄 Sector RRG',
  'nav.thesisWorkbench': '📜 Berkshire Value Investing',
  'nav.group.research': '🔬 Research & Compare',
  'nav.group.screenerFactors': '🎯 Screening & Factors',
  'nav.group.macroMarket': '🌐 Macro & Market',
  'nav.group.alphaResearch': '🧪 Alpha & Factors',
  'nav.group.strategyLab': '📈 Strategy & Backtest',
  'nav.group.executionMonitor': '⚡ Execution & Monitor',
  'nav.group.portfolioRisk': '💼 Portfolio & Risk',
  'nav.group.workbench': '🛠️ Workbench',
  'nav.admin': 'Admin',
  'nav.brand': 'TickerLab Investment Analysis',

  // ===== Common =====
  'common.loading': 'Loading...',
  'common.confirm': 'Confirm',
  'common.cancel': 'Cancel',
  'common.delete': 'Delete',
  'common.save': 'Save',
  'common.refresh': 'Refresh',
  'common.search': 'Search',
  'common.error': 'Error',
  'common.success': 'Success',
  'common.warning': 'Warning',
  'common.minutes': 'min',
  'common.seconds': 's',
  'common.empty': 'No data',
  'common.networkError': 'Network error',
  'common.operation': 'Actions',
  'common.status': 'Status',
  'common.actions': 'Actions',
  'common.createdAt': 'Created At',
  'common.symbol': 'Symbol',
  'common.export': 'Export',
  'common.retry': 'Retry',
  'common.value': 'Value',
  'common.analyze': 'Analyze',

  // ===== Research toolkit (ROADMAP P1) =====
  'research.title': 'Research Toolkit',
  'research.tab.report': 'Report Parsing',
  'research.tab.sentiment': 'Sentiment',
  'research.tab.liquidity': 'Liquidity',
  'research.noSymbol': 'No symbol identified in this analysis; sentiment/liquidity need one',
  'research.report.upload': 'Drag or click to upload a PDF / Excel report',
  'research.report.tip': 'Key financial fields are extracted automatically (≤20MB)',
  'research.report.confidence': 'Confidence',
  'research.report.warnings': 'Parse warnings',
  'research.report.failed': 'Report parsing failed',
  'research.sentiment.run': 'Analyze last 7 days',
  'research.sentiment.news': 'News count',
  'research.sentiment.overall': 'Overall',
  'research.sentiment.noNews': 'No recent news',
  'research.sentiment.failed': 'Sentiment analysis failed',
  'research.liquidity.run': 'Compute liquidity',
  'research.liquidity.note': 'Metrics use synthetic proxy data; for relative comparison only',
  'research.liquidity.score': 'Liquidity Score',
  'research.liquidity.rating': 'Rating',
  'research.liquidity.adv': 'Avg Daily Amount',
  'research.liquidity.turnover': 'Avg Turnover',
  'research.liquidity.amihud': 'Amihud Illiq',
  'research.liquidity.spread': 'CS Spread',
  'research.liquidity.failed': 'Liquidity computation failed',

  // ===== Chat RAG mode (ROADMAP P1) =====
  'chat.rag.mode': 'Knowledge Retrieval',
  'chat.rag.placeholder': 'Ask anything; retrieves your past decisions + knowledge base (Enter to send)',
  'chat.rag.hint': 'Answers are grounded in your own decision history and the built-in knowledge base; sources shown below',

  // ===== Portfolio & Risk (ROADMAP P2) =====
  'common.view': 'View',
  'risk.run': 'Generate Risk Snapshot',
  'risk.done': 'Risk snapshot generated',
  'risk.failed': 'Failed to generate risk snapshot',
  'risk.hint': 'Computes VaR / CVaR / volatility / drawdown for current holdings and keeps a snapshot',
  'risk.history': 'Snapshot History',
  'risk.var95': 'VaR 95%',
  'risk.cvar95': 'CVaR 95%',
  'risk.vol': 'Ann. Vol',
  'risk.maxdd': 'Max Drawdown',
  'risk.sharpe': 'Sharpe',
  'risk.hhi': 'HHI',
  'backtest.dialogTitle': 'Decision Backtest Result',
  'backtest.period': 'Period',
  'backtest.failed': 'Decision backtest failed',
  'sbhist.title': '📜 Backtest History',
  'sbhist.strategy': 'Strategy',
  'sbhist.period': 'Days',
  'sbhist.annualReturn': 'Ann. Return',
  'pref.title': 'User Preferences',
  'pref.holdingDays': 'Typical Holding Days',
  'pref.holdingDaysHint': 'Personalizes decision advice and the prompt patch',
  'pref.patchPreview': 'Prompt patch preview',
  'export.title': 'Data Export',
  'export.note': 'Export your own data (CSV formula-injection safe); up to 10,000 rows',
  'export.failed': 'Export failed',
  'export.type.portfolio': 'Portfolio',
  'export.type.decisions': 'Decisions',
  'export.type.backtests': 'Decision Backtests',
  'export.type.risk_snapshots': 'Risk Snapshots',
  'export.type.watchlists': 'Watchlists',
  'export.type.chat_sessions': 'Chat Sessions',

  // ===== Auth =====
  'auth.brand.subtitle': 'TickerLab Intelligent Investment Platform',
  'auth.tab.login': 'Sign In',
  'auth.tab.register': 'Register',
  'auth.username.placeholder': 'Username (3-64 chars)',
  'auth.email.placeholder': 'Email (optional)',
  'auth.invite.placeholder': 'Invite code (required when invite-only)',
  'auth.password.placeholder': 'Password',
  'auth.passwordConfirm.placeholder': 'Confirm password',
  'auth.submit.login': 'Sign In',
  'auth.submit.register': 'Register & Sign In',
  'auth.warn.empty': 'Please enter username and password',
  'auth.warn.passwordMin': 'Password must be at least 8 characters',
  'auth.warn.passwordMismatch': 'Passwords do not match',
  'auth.success.registered': 'Registered successfully',
  'auth.success.login': 'Welcome to AlphaLens',
  'auth.error.failed': 'Authentication failed, please check your credentials',
  'auth.toast.loggedOut': 'Signed out',
  'auth.logout': 'Sign Out',
  'auth.toast.langZh': '已切换到中文',
  'auth.toast.langEn': 'Switched to English',
  'auth.feature.quant': '✨ TickerLab Quant Analysis',
  'auth.feature.backtest': '📊 Institutional Backtesting',
  'auth.feature.cppi': '🛡️ CPPI Capital Protection',

  // ===== Enums =====
  'enum.decision.buy': 'Buy',
  'enum.decision.sell': 'Sell',
  'enum.decision.hold': 'Hold',
  'enum.confidence.high': 'High',
  'enum.confidence.medium': 'Medium',
  'enum.confidence.low': 'Low',
  'enum.status.queued': 'Queued',
  'enum.status.running': 'Running',
  'enum.status.completed': 'Completed',
  'enum.status.failed': 'Failed',
  'enum.status.ready': 'Ready',
  'enum.status.evaluated': 'Evaluated',
  'enum.status.missingData': 'Missing Data',
  'enum.market.cn': 'CN',
  'enum.market.hk': 'HK',
  'enum.market.us': 'US',
  'enum.quality.good': 'Good',
  'enum.quality.degraded': 'Degraded',
  'enum.quality.partial': 'Partial',
  'enum.quality.stale': 'Stale',
  'enum.quality.missing': 'Missing',
  'enum.quality.unknown': 'Unknown',
  'enum.phase.pre_market': 'Pre-market',
  'enum.phase.intraday': 'Intraday',
  'enum.phase.lunch': 'Lunch Break',
  'enum.phase.near_close': 'Near Close',
  'enum.phase.after_hours': 'After Hours',
  'enum.phase.non_trading': 'Non-trading',
  'enum.phase.unknown': 'Unknown',
  'enum.sentiment.positive': 'Positive',
  'enum.sentiment.negative': 'Negative',
  'enum.sentiment.neutral': 'Neutral',

  // ===== History =====
  'history.title': 'Analysis History',
  'history.col.decision': 'Decision',
  'history.col.confidence': 'Confidence',
  'history.col.status': 'Status',
  'history.col.createdAt': 'Submitted At',
  'history.empty': 'No analyses yet',
  'history.error.load': 'Failed to load analysis history',

  // ===== Batch =====
  'batch.col.batch': 'Batch',
  'batch.col.name': 'Name',
  'batch.col.total': 'Total',
  'batch.col.progress': 'Progress (done/failed)',
  'batch.col.createdAt': 'Created At',
  'batch.error.load': 'Failed to load batch history',
  'batch.confirm.delete':
    'Delete this batch? All its sub-analyses will be removed permanently.',
  'batch.success.deleted': 'Batch deleted',
  'batch.error.delete': 'Delete failed',

  // ===== Tasks =====
  'tasks.error.load': 'Failed to load background tasks',

  // ===== Alerts =====
  'alerts.col.rule': 'Rule',
  'alerts.col.symbol': 'Symbol',
  'alerts.col.type': 'Type',
  'alerts.col.threshold': 'Threshold',
  'alerts.col.enabled': 'Enabled',
  'alerts.col.lastTriggered': 'Last Triggered',

  // ===== Theme =====
  'theme.toggle.toLight': 'Switch to light',
  'theme.toggle.toDark': 'Switch to dark',
  'theme.switched.toDark': 'Switched to dark mode',
  'theme.switched.toLight': 'Switched to light mode',
  // ===== Market opportunities (ROADMAP P3) =====
  'ff.marketTitle': 'Market Fund Flow',
  'ff.north': 'Northbound Net',
  'ff.south': 'Southbound Net',
  'ff.main': 'Main Force Net',
  'ff.superLarge': 'Super Large',
  'ff.large': 'Large Orders',
  'ff.small': 'Small Orders',
  'ff.trend': 'Trend',
  'ff.topIn': 'Top Sector Inflow',
  'ff.topOut': 'Top Sector Outflow',
  'ff.mainNet': 'Main Net',
  'ff.changePct': 'Change %',
  'ff.rules': 'Fund Flow Alert Rules',
  'ff.addRule': 'Add Rule',
  'ff.indicator': 'Indicator',
  'ff.direction': 'Direction',
  'ff.threshold': 'Threshold (CNY)',
  'ff.above': 'Above',
  'ff.below': 'Below',
  'ff.triggered': 'Trigger History',
  'ff.market': 'Market',
  'ff.loadFailed': 'Failed to load fund flow',
  'ff.snapshotTitle': 'Intraday Fund Flow Snapshot',
  'ff.trendTitle': '5-Day Trend & Northbound Analysis',
  'ff.trendStatus': 'Trend Status',
  'ff.trendInflow': 'Continuous Inflow',
  'ff.trendOutflow': 'Continuous Outflow',
  'ff.trendNeutral': 'Neutral / Oscillation',
  'ff.northCum5d': '5D Cum. Northbound Net',
  'ff.northAvg5d': '5D Avg. Northbound Net',
  'ff.consecutiveDays': 'Consecutive Inflow Days',
  'ff.volatility': 'Northbound Net Volatility (StdDev)',
  'ff.samplePeriod': 'Effective Sample Period',
  'ff.days': 'days',
  'ff.trendSummaryInflow': 'Northbound funds show continuous net inflow, indicating strong institutional buying.',
  'ff.trendSummaryOutflow': 'Northbound funds show recent net outflow, suggest cautious liquidity positioning.',
  'ff.trendSummaryNeutral': 'Northbound funds are balanced between long and short sides, no clear directional trend yet.',
  'ah.title': 'AH Premium Arbitrage',
  'ah.hint': 'A/H premium = (A price - H price x FX) / (H price x FX); positive means A trades at premium',
  'ah.scan': 'Rescan',
  'ah.pair': 'Pair',
  'ah.premium': 'Premium',
  'ah.snapshots': 'Scan Snapshots',
  'ah.pairCount': 'Pairs',
  'ah.avgPremium': 'Avg Premium',
  'ah.loadFailed': 'Failed to load arbitrage data',
  'ah.scanFailed': 'Arbitrage scan failed',
  'cal.title': 'Earnings Calendar',
  'cal.daysAhead': 'Days Ahead',
  'cal.allMarkets': 'All Markets',
  'cal.company': 'Company',
  'cal.marketCol': 'Market',
  'cal.reportDate': 'Report Date',
  'cal.period': 'Period',
  'cal.loadFailed': 'Failed to load earnings calendar',

  'nav.reports': '📊 Reports',
  'rep.title': 'Research Reports',
  'rep.weekly': 'Generate Weekly',
  'rep.monthly': 'Generate Monthly',
  'rep.type': 'Type',
  'rep.range': 'Period',
  'rep.preview': 'Report Preview',
  'rep.loadFailed': 'Failed to load reports',
  'rep.genFailed': 'Report generation failed',

  'audit.title': 'Audit Logs',
  'audit.action': 'Action',

  // ===== Auto Research pipeline (ALENS-10) =====
  'autoResearch.title': 'Auto Research Pipeline',
  'autoResearch.subtitle': 'Screen → Rigor → Multi-lens → Adversarial → Forced verdict',
  'autoResearch.symbol': 'Symbol',
  'autoResearch.symbolPlaceholder': 'e.g. sh.600519',
  'autoResearch.name': 'Name',
  'autoResearch.namePlaceholder': 'optional, for readability',
  'autoResearch.submit': 'Run Research',
  'autoResearch.running': 'Researching...',
  'autoResearch.node.init': 'Created',
  'autoResearch.node.dataPack': 'Data Pack',
  'autoResearch.node.screen': 'Quality Screen',
  'autoResearch.node.rigor': 'Rigor Checks',
  'autoResearch.node.multiLens': 'Multi-lens',
  'autoResearch.node.adversarial': 'Adversarial',
  'autoResearch.node.verdict': 'Verdict',
  'autoResearch.node.report': 'Report',
  'autoResearch.node.done': 'Done',
  'autoResearch.result.title': 'Research Verdict',
  'autoResearch.result.downloadPdf': 'Download PDF',
  'autoResearch.verdict.pass': '✅ Pass (worth further study)',
  'autoResearch.verdict.reject': '❌ Reject (red line)',
  'autoResearch.verdict.grey_zone': '🟡 Grey Zone (insufficient evidence)',
  'autoResearch.verdict.confidence': 'Confidence',
  'autoResearch.verdict.score': 'Score',
  'autoResearch.verdict.mirrorTest': 'Mirror test (5 sentences)',
  'autoResearch.strategy.title': 'Three-tier Strategy',
  'autoResearch.strategy.aggressive': 'Aggressive',
  'autoResearch.strategy.balanced': 'Balanced',
  'autoResearch.strategy.conservative': 'Conservative',
  'autoResearch.strategy.tier': 'Tier',
  'autoResearch.strategy.action': 'Action',
  'autoResearch.strategy.priceRange': 'Price Range',
  'autoResearch.strategy.position': 'Max Position',
  'autoResearch.action.buy': 'Buy',
  'autoResearch.action.wait': 'Wait',
  'autoResearch.action.avoid': 'Avoid',
  'autoResearch.invalidation': 'Invalidation conditions (reassess when triggered)',
  'autoResearch.dataGaps': 'Open questions (left blank)',
  'autoResearch.guardrails': 'Verdict guardrail notes (rule-layer rewrites)',
  'autoResearch.tab.conclusion': 'Verdict',
  'autoResearch.tab.screening': 'Screening',
  'autoResearch.tab.rigor': 'Rigor',
  'autoResearch.tab.lenses': 'Multi-lens',
  'autoResearch.tab.adversarial': 'Adversarial',
  'autoResearch.tab.report': 'Full Report',
  'autoResearch.screening.rejected': 'Red line triggered: ',
  'autoResearch.screening.insufficient': 'Insufficient data: financial periods below significance threshold, skipped deep research',
  'autoResearch.screening.passed': 'Passed screening, no red lines',
  'autoResearch.screening.skipped': 'Short-circuited, stage not executed',
  'autoResearch.rigor.grade': 'Data grade',
  'autoResearch.rigor.result': 'Result',
  'autoResearch.rigor.detail': 'Detail',
  'autoResearch.lens.bullish': 'Bullish',
  'autoResearch.lens.neutral': 'Neutral',
  'autoResearch.lens.bearish': 'Bearish',
  'autoResearch.lens.name.value': 'Value',
  'autoResearch.lens.name.quality': 'Quality',
  'autoResearch.lens.name.growth': 'Growth',
  'autoResearch.claim.upheld': 'Upheld',
  'autoResearch.claim.weakened': 'Weakened',
  'autoResearch.claim.refuted': 'Refuted',
  'autoResearch.claim.challenge': 'Challenge',
  'autoResearch.claim.evidence': 'Evidence',
  'autoResearch.history.title': 'Research History',
  'autoResearch.history.verdict': 'Verdict',
  'autoResearch.history.status': 'Status',
  'autoResearch.history.time': 'Created',
  'autoResearch.history.empty': 'No research yet. Enter a symbol to run your first auto research',
  'autoResearch.error.symbolRequired': 'Symbol is required',
  'autoResearch.error.create': 'Failed to start research',
  'autoResearch.error.fetchResult': 'Failed to fetch research result',
  'autoResearch.error.downloadPdf': 'PDF download failed',
  'autoResearch.error.failed': 'Research failed',

}